import { gql } from '@apollo/client';

export const UPDATE_CUSTOMER = gql`
  mutation updateCustomer($customerId: ID!) {
    updateCustomer(input: $input, id: $customerId)
      @rest(type: "Customer", path: "/v4/customers/{args.id}", method: "PUT")
  }
`;

export const INVITE_COLLEAGUE = gql`
  mutation inviteColleague($customerId: ID!) {
    inviteColleague(input: $input)
      @rest(type: "Customer", path: "/v4/users/invite", method: "POST")
  }
`;
